"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-topic-add.tsx
var TopicAdd = function TopicAdd(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M8.33333 35C7.41667 35 6.63194 34.6736 5.97917 34.0208C5.32639 33.3681 5 32.5833 5 31.6667V8.33333C5 7.41667 5.32639 6.63194 5.97917 5.97917C6.63194 5.32639 7.41667 5 8.33333 5H23.3333V8.33333H8.33333V31.6667H31.6667V16.6667H35V31.6667C35 32.5833 34.6736 33.3681 34.0208 34.0208C33.3681 34.6736 32.5833 35 31.6667 35H8.33333ZM13.3333 28.3333V25H26.6667V28.3333H13.3333ZM13.3333 23.3333V20H26.6667V23.3333H13.3333ZM13.3333 18.3333V15H26.6667V18.3333H13.3333ZM28.3333 15V11.6667H25V8.33333H28.3333V5H31.6667V8.33333H35V11.6667H31.6667V15H28.3333Z",
    fill: "#616A73"
  }));
};

var _default = TopicAdd;
exports.default = _default;